
import Home from "./pages/home/Home"
import Login from "./pages/login/Login";
import Register from "./pages/login/Register";
import Profile from "./pages/profile/Profile";
import Messenger from "./pages/messenger/Messenger";
import Setting from "./pages/setting/Setting"
import { AuthContext } from './context/AuthContext';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";
import { useContext } from "react";


function App() {
  //const loggedIn = localStorage.token ? true : false;
  const {isFetching} = useContext(AuthContext);
  const loggedIn = localStorage.token ? true : false;

  return  (
    <Router>
      <Switch>
        <Route exact path="/">
            {isFetching || loggedIn ? <Home /> : <Register />}
        </Route>
        <Route path="/login">
            {isFetching || loggedIn? <Redirect to="/"/> : <Login />}
        </Route>
        <Route path="/register">
            { !loggedIn? <Redirect to="/login"/> : <Register  />}
        </Route>
        <Route path="/messenger/:id">
            { !loggedIn? <Redirect to="/login"/> : <Messenger/>}
        </Route>
        <Route path="/profile/:loggedInname">
            { !loggedIn? <Redirect to="/login"/> : <Profile />}     
        </Route>
        <Route path="/Setting">
            { !loggedIn? <Redirect to="/login"/> : <Setting />}     
            
        </Route>
      </Switch>
    </Router>
  )   ;
}

export default App;
